<template>
  <div class="home">
    <a href="http://hands.agency"  target="_blank" et un rel="noopener" >
        <svg class="logo" version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
            y="0px" viewBox="0 0 960 431.96" style="enable-background:new 0 0 960 431.96;" xml:space="preserve">
            <g>
                <path class="st0" d="M901.06,264.75c-0.56-5.94-4.38-15.91-23.56-15.98c-11.26-0.04-24.29,3.19-33.11,5.63
                c-18.4,5.08-35.88,12.67-52.79,20.01c-9.03,3.92-18.62,7.57-27.9,11.15c-5.73,2.2-9.95,4.09-14.81,5.88
                c-0.91,0.32-1.81,0.64-2.74,0.96c-0.07,0.03-0.14,0.05-0.21,0.07c-0.12,0.04-0.23,0.07-0.35,0.12c-2.89,0.97-6.12,1.91-10.05,2.87
                l-4.14,0.62c-0.93,0.08-1.86,0.14-2.79,0.13c-0.41,0-0.81-0.01-1.22-0.03c-6.85-0.32-9.07-2.65-10.8-6.86
                c-2.2-5.38-1.46-11.3-0.32-16.89c1.54-7.57,3.28-14.89,5.19-21.77c2.65-9.55,20.21-48.53,25.84-57.16c2.09-3.2,3.7-6.16,4.92-9.06
                c0.77-1.83,0.65-4.07-0.32-6.31c-0.92-2.12-2.88-4.74-5.63-5.74c-0.7-0.26-1.44-0.39-2.19-0.39c-3.29-0.01-6.41,2.48-7.94,6.34
                c-0.17,0.44-0.32,0.9-0.45,1.35c-0.15,0.43-0.47,0.88-0.6,1.09c-2.77,4.51-16.05,29.54-20.42,36.9c-4.2,7.08-8.36,14.1-10.98,18.38
                c-4.2,6.86-9.39,13.12-14.79,19.12c-0.27-1.53-0.78-3.06-1.57-4.59c-3.08-6.03-8.69-9.25-16.65-9.59
                c-0.43-0.02-0.86-0.03-1.29-0.03c-4.04-0.01-8.58,0.42-12.95,1.77c-5.89,1.82-17.26,6.04-28.43,15.75
                c-7.89,6.85-19.38,20.35-22.95,34.79c-0.1,0.12-0.76,4.13-0.8,4.15c-1.51,0.12-7.04,0.16-8.12,0.1c-2.18-0.14-5.33-0.67-7.48-1.38
                c-6.03-1.98-9.69-3.7-11.62-8.21c-1.69-3.95-2.12-8.14-1.33-12.78c0.17-0.98,0.36-1.96,0.54-2.94c0.47-2.47,0.95-5.03,1.15-7.66
                c0.17-2.21-0.73-4.55-2.46-6.4c-1.64-1.74-3.77-2.83-5.86-2.99l-0.26-0.02l-0.27,0.02c-4.35,0.33-5.61,2.57-7.21,5.42l-0.96,1.67
                c-0.15,0.26-0.21,0.36-0.54,0.98c-3.1,5.05-5.89,9.2-9.45,13.04c-5.64,6.08-13.47,13.43-24.15,16.48
                c-1.21,0.34-2.24,0.52-3.04,0.52c-1.03,0-1.55-0.08-1.89-1.82c-0.79-3.99-0.9-7.1-0.32-9.52c1.12-4.72,2.67-9.51,4.16-14.13
                c0.86-2.65,1.71-5.3,2.51-7.96c0.77-2.59,1.16-5.05,1.17-7.3c0.02-4.11-2.35-7.3-6.5-8.76c-0.82-0.29-1.64-0.43-2.42-0.44
                c-2.93-0.01-4.74,1.87-6.03,3.22c-2.11,2.19-4.32,4.3-6.42,6.28c-2.42,2.29-4.81,4.62-7.2,6.96c-7.51,7.32-15.27,14.89-23.94,21.13
                c-6.3,5.15-12.69,7.75-20.37,10.07c-1.66,0.5-3.67,0.78-5.66,0.77c-4.65-0.02-7.2-1.46-7.27-2.24l-0.04-0.3
                c-1.87-10.96,5.02-30.33,7.29-36.7c0.14-0.39,0.29-0.79,0.45-1.21c1.16-3.03,3.55-9.27-1.76-12.32l-0.11-0.09l-0.28-0.13
                l-0.79-0.42c0.58-2.9,0.12-5.71-1.4-8.17c-2.6-4.23-8.08-6.87-14.29-6.89c-2.27-0.01-4.52,0.33-6.72,1.01
                c-12.28,3.86-27.07,12.4-37.72,21.76c-7.14,6.29-12.35,12.38-17.98,19.58c-4.98,6.38-10.32,14.23-12.19,24.15
                c-0.29,1.59-0.53,2.47-1.49,2.86c-2.91,1.16-5.75,2.38-8.64,3.61c-5.36,2.3-11.25,4.28-16.8,6.1c-3.15,1.04-6.11,1.56-8.78,1.54
                c-4.51-0.01-8.34-1.49-11.72-4.52c-4.82-4.31-7.51-10.26-9.31-14.96c-1.56-4.08-3.03-8.2-4.5-12.33
                c-2.35-6.63-4.79-13.48-7.62-20.09c-3.82-8.91-9.93-13.26-18.65-13.29c-1.59-0.01-3.29,0.14-5.07,0.42
                c-5.69,0.92-11.82,2.61-18.75,5.18c-9.76,3.61-19.64,8.58-30.01,15.13c1.04-1.18,2.08-2.36,3.11-3.55
                c4.39-5.08,8.72-10.21,13.05-15.34c2.77-3.28,5.54-6.56,8.34-9.83c0.85-1,1.7-2.01,2.54-3.02c5.9-7.02,11.46-13.65,19.33-18.13
                c6.28-3.58,12.05-8.05,17.63-12.37c1.41-1.09,2.82-2.18,4.22-3.25c2.02-1.52,4.03-3.04,6.04-4.56
                c8.21-6.18,16.67-12.56,24.63-19.38c23.42-20.08,42.89-39.86,59.52-60.49c2.67-3.31,5.04-7.46,7.04-12.34
                c1.07-2.6,0.79-5.42-0.75-7.75c-1.73-2.58-4.8-4.18-8.04-4.19c-0.36,0-0.73,0.02-1.09,0.06c-6.25,0.66-11.07,4-15.31,6.95
                l-0.95,0.66c-12.33,8.5-23.24,18.87-34.25,29.64c-4.63,4.53-9.19,9.14-13.75,13.74l-5.84,5.89l-3.57,3.56
                c-2.81,2.79-5.61,5.58-8.34,8.44c-4.63,4.84-9.21,9.74-13.78,14.64l-3.74,3.99c-1.93,2.07-3.88,4.12-5.82,6.17
                c-4.75,5-9.66,10.17-14.29,15.49c-6.98,8.02-13.57,13.57-20.71,17.48c-2.2,1.2-4.28,2.57-6.29,3.89c-0.69,0.46-1.38,0.91-2.08,1.36
                c-1.81,1.17-3.62,2.36-5.43,3.55c-3.51,2.31-7.15,4.71-10.79,6.88c-4.22,2.52-8.47,4.99-12.73,7.45
                c-6.29,3.64-12.8,7.41-19.1,11.32c-0.52,0.34-3.3,1.93-4.04,2.31c-1.94,1.03-1.04,0.62-4.37,2.36c-0.78,0.35-1.78,0.92-2.26,1.15
                c-1.51,0.71-2.37,1.01-3.64,1.67c-3.97,2.06-7.89,4.19-11.82,6.31c-5.31,2.87-10.8,5.84-16.25,8.58
                c-7.16,3.61-15.06,7.25-24.14,11.14l-0.81,0.34c-12.93,5.53-26.29,11.26-39.6,16.37c-1.15,0.45-2.29,0.82-3.44,1.23
                c-1.46,0.76-2.85,1.37-3.91,2.16c-2.92,2.19-0.83,10.31,3.26,12.12c1.61,0.71,4.67,0.51,6.73-0.07
                c15.28-5.63,29.22-11.24,42.42-17.09c13.06-5.78,27-12.61,43.86-21.5c9.65-5.09,19.21-10.67,28.46-16.05
                c3.44-2.01,6.88-4.02,10.35-6c4.62-2.66,9.23-5.35,13.82-8.05c-0.25,0.3-0.49,0.59-0.75,0.88c-3.4,3.97-6.81,7.92-10.27,11.84
                c-2.64,2.97-5.29,5.93-7.94,8.9c-3.78,4.22-7.56,8.45-11.29,12.71c-1.83,2.09-3.61,4.21-5.39,6.34c-2.8,3.35-5.69,6.82-8.7,9.99
                c-2.35,2.47-3.36,4.85-3.37,7.93c-0.03,2.7,0.91,5.14,2.63,6.87c1.58,1.6,3.71,2.48,5.99,2.49c1.48,0,2.96-0.35,4.4-1.05
                c1.81-0.88,3.61-2.04,5.35-3.45c1.51-1.23,3-2.51,4.47-3.8c2.17-1.9,4.22-3.69,6.42-5.31c9.19-6.83,18.99-14.08,29-20.98
                c5.12-3.53,10.7-6.84,16.59-9.83c5.99-3.05,12.33-5.6,18.31-7.96c5.25-2.07,9.7-3.44,14.38-3.42c4.12,0.02,5.22,0.7,6.47,4.04
                c1.78,4.72,3.47,9.58,5.11,14.27c1.71,4.84,3.47,9.85,5.31,14.75c2.66,7.06,6.05,15.14,12.65,21.49c7.07,6.8,14.31,9.54,22.27,9.56
                c1.25,0,2.71,0,3.99-0.16c3.85-0.49,8.3-1.34,13.11-2.87c9.39-2.99,20.41-9.66,20.47-9.7c0.05,0.08,1.97,2.85,2.67,3.53
                c3.88,3.72,8.79,5.62,14.58,5.64c1.97,0.01,4.09-0.2,6.32-0.63l0.28-0.07c5.95-1.66,12.34-4.49,18.98-8.41
                c10.77-6.35,17.48-11.36,25.77-19.7c0.13,1.86,0.43,3.73,0.78,5.73c1.61,9.07,11.11,15.19,23.63,15.24
                c3.12,0.01,6.25-0.37,9.47-1.18c8.26-2.47,11.5-4.31,16.51-7.35c10.84-6.57,20.12-14.85,27.86-22.29
                c-1.09,6.04-1.94,12.26,0.26,18.81c3.17,9.4,9.5,14.6,17.85,14.63c2.46,0.01,5.06-0.45,7.74-1.35c8.13-2.73,15.73-7.45,22.61-14.03
                c2.11-2.02,4.29-3.95,6.58-5.97c3.03,11.19,9.94,18.36,21.07,21.9c3.93,1.25,8.06,1.87,12.64,1.88c3.02,0.01,6.23-0.24,10.16-0.78
                v-0.02c2.44-0.3,2.42-0.36,4.93-0.87c3.92,4.81,7.47,5.83,13.08,5.85c1.84,0.01,4.01-0.22,5.34-0.48
                c4.36-0.84,11.1-2.92,13.99-4.34c16.46-8.06,20.15-11.7,32.87-21.79c9.91-7.87,18.37-16.86,27.84-27.97
                c-0.96,4.61-1.91,9.31-2.7,14c-1.47,8.67,0.19,16.97,4.8,24c5.6,8.51,14.17,13.21,24.12,13.25c2.97,0.01,6.04-0.4,9.14-1.2
                c3.86-1.01,9.56-3.02,15.78-5.41v-0.04c2.28-0.85,4.57-1.75,7.86-2.91c12.35-4.37,24.47-9.95,36.13-15.01
                c15.64-6.78,30.16-13.57,45.84-18.23c9.82-2.92,20.17-5.62,29.33-5.58c1.67,0.01,3.28,0.11,4.79,0.29c3.3,0.41,5.25,1.87,5.66,3.06
                c0.09,0.25,0.3,0.84-0.7,2.25c-4.18,5.89-13.27,11.07-20.59,15.23c-2.85,1.62-5.91,3.25-9.23,4.94c-0.28-3.2-2.71-6.16-5.83-7
                c-4.33-1.17-8.36,1.47-9.7,5.56c-1.5,4.56-2.68,9.05-3.2,13.84c-0.32,2.96,1.71,5.56,4.29,6.9c4.29,2.99,12.09-0.71,12.59-0.85
                c4.09-1.94,7.89-3.81,11.47-5.69l1.26-0.65C877.35,296.55,902.84,283.24,901.06,264.75z M281.13,179.26
                c27.39-26.63,52-56.22,83.65-79.03c-1.44,9.66-68.94,74.04-85.88,82.07C279.92,180.88,280.41,179.96,281.13,179.26z M377.56,274.76
                c8.1-10.29,16.15-18.47,26.33-26.72c4.23-3.43,16.74-10.59,22.27-12.77c3.02-1.18,6.41-2.83,8.6-0.62c1.2,1.2,1.89,2.57-0.46,5.22
                c-10.69,12.06-22.94,21.91-32.93,28.81c-8.51,5.87-27.98,16.9-30.07,17.4C372.85,281.14,374.9,278.14,377.56,274.76z
                    M431.09,261.97c-4.16,7.19-8.62,12.71-14.34,18.39c-7.6,6.49-11.49,9.57-19.7,14.36c-6.67,3.87-11.93,6.79-18.41,7.94
                c-6.31,1.11-8.7-1.22-8.98-2.02c0.44-0.36,12.28-7.65,17.17-10.98c19.38-13.24,25.08-16.51,38.27-28.7
                c3.17-2.93,10.02-9.44,12.97-13.29C437.65,249.35,437.28,251.29,431.09,261.97z M624.04,305.1c10.45-4.27,41.8-20.77,41.8-20.77
                C652.58,295.01,632.93,309.97,624.04,305.1z M679.77,261.15c-0.73,6.29-5.7,8.22-11.24,11.6c-9.63,5.87-23.51,10.64-35.62,15.93
                c-4.97,2.17-7.92,3.01-12.55,4.78c0,0,0.07-3.36,1.1-6.13c3.15-8.43,7.39-13.98,13.71-19.57c6.03-5.35,12.94-10.54,20.49-13.67
                c4.92-2.03,10.12-3.12,15.56-2.45c1.9,0.24,3.78,0.93,5.65,1.91C680.95,256.11,679.87,260.27,679.77,261.15z" />
            </g>
        </svg>
    </a>

    <div ref="intro" class="intro-container">
      <h1>PAPER PLEASE!</h1>
      <p style="font-size: 1.2em; margin-bottom: 20px; line-height: 1.4em">Grab the paper and keep <br>your hands clean.</p><br>
      <p
        @click="start"
        @toushstart="start"
        ref="start"
        style="opacity: .3; pointer-events: none; cursor: pointer;"
      >PLAY
        <span>
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 182 7" style="enable-background:new 0 0 182 7;" xml:space="preserve">
            <path class="st0" d="M1.5,4.5c25-5,168-1,179,1"/>
          </svg>
        </span>
      </p>
    </div>

    <div ref="score" class="score-wrapper hidden">
      <h1>{{ score }}</h1>
      <p>DAYS</p>
      <div class="points-container">
        <div v-for="point in points" class="point"
          :style="`transform: translate(-50%, ${point.offset}px); opacity: ${1 - point.time}`"
        >
          +{{ point.bonus }}
        </div>
      </div>
    </div>

    <div ref="tuto" style="top: 50%" class="intro-container hidden">
      <p style="font-size: 1.2em; margin-bottom: 20px; text-transform: uppercase; line-height: 1.4em;">Tap on the sides or<br> use the arrow keys</p><br>      
    </div>

    <div ref="sound" class="sound-wrapper"
      @click="toggleMute"
      @toushstart="toggleMute"
    ></div>

    <div ref="end" class="intro-container hidden"
      style="top: 50%"
    >
      <h1>GAME OVER</h1>
      <div class="intro-score-wrapper">
        <p style="text-transform: uppercase;">you made it through</p> <br>
        <p class="intro-score">
        {{ score }}
        </p><br>
        <p style="font-size: 0.8em">DAYS</p> <br>
      </div>
      <p
        @click="reset"
        @toushstart="reset"
        style="cursor: pointer;"
      >TRY AGAIN
        <span>
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 182 7" style="enable-background:new 0 0 182 7;" xml:space="preserve">
            <path class="st0" d="M1.5,4.5c25-5,168-1,179,1"/>
          </svg>
        </span>
      </p>
      <br>
      <p style="margin-top: 80px">SHARE</p>
      <div class="share-links">
        <a href="https://www.facebook.com/sharer/sharer.php?u=https://paperplease.run" target="_blank"><i class="icon-facebook"></i></a>
        <a href="https://twitter.com/intent/tweet?text=Grab%20toilet%20paper%20and%20run!%20But%20always%20keep%20your%20hands%20clean.%20%0Ahttps%3A//paperplease.run/" target="_blank"><i class="icon-twitter"></i></a>
        <a href="https://wa.me/?text=Grab%20toilet%20paper%20and%20run!%20But%20always%20keep%20your%20hands%20clean.%20%0Ahttps%3A//paperplease.run/" target="_blank"><i class="icon-whatsapp"></i></a>
      </div>
    </div>

  </div>
</template>

<script>
import WebglManager from '@/glxp/webglManager'
import RAF from '@/js/utils/raf'
import Sound from '@/glxp/sound'
import playConfig from '@/config/playConfig'


export default {
  name: 'home',
  data(){
    return {
      score: 0,
      points: [],
      muted: false
    }
  },

  mounted () {
    this.$nextTick(()=>{
      this.glxp = WebglManager.getScene('demo')
      this.glxp.view = this
      WebglManager.loadScene('demo').then(()=>{
        WebglManager.activate('demo')
        this.$refs["start"].style.pointerEvents = 'all'
        this.$refs["start"].style.opacity = 1
      })

      this.glxp.on('game-over', ()=>{
        setTimeout(() => {
          this.$refs["end"].classList.remove('hidden')
          this.$refs["score"].classList.add("hidden")
          window.document.body.classList.remove("grabbable")
          window.document.body.classList.remove("no-cursor")
        }, playConfig.gameOverScreenDelayMs)
      })

      this.glxp.on('bonus', (bonus)=>{
        this.points.push({
          bonus: bonus,
          time: 0,
          offset: 0,
        })
      })

    RAF.suscribe("home-view", this.update.bind(this))
    window.document.body.classList.add("grabbable")

    if (window.visualViewport) {        
      window.visualViewport.addEventListener('scroll', (event)=>{ this.handleViewPort(event) });
      window.visualViewport.addEventListener('resize', (event)=>{ this.handleViewPort(event) });
    }

    this.handleViewPort()

    })
  },
  beforeDestroy () {
    WebglManager.desactivate('demo')
    RAF.unsuscribe("home-view")
  },
  methods: {
    start(evt){
      evt.stopPropagation()
      this.$refs["intro"].classList.add("hidden")
      this.$refs["score"].classList.remove("hidden")
      this.$refs["tuto"].classList.remove("hidden")
      this.glxp.start()
      Sound.play('switch')
      window.document.body.classList.add("no-cursor")
      setTimeout(() => {
        this.glxp.hand.on('mouve', ()=>{
          this.$refs["tuto"].classList.add("hidden")
        })
      }, playConfig.moveListenerDelayMs)
    },

    reset(){
      this.$refs["end"].classList.add('hidden')
      this.$refs["score"].classList.remove("hidden")
      window.document.body.classList.add("grabbable")
      window.document.body.classList.add("no-cursor")
      this.score = 0
      this.glxp.reset()
      Sound.play('switch')
    },

    handleViewPort(event){
      requestAnimationFrame(() => {
        this.glxp.resize()
        this.glxp.post.rt.onResize()
      })
    },

    toggleMute(){
      this.muted = !this.muted
      Sound.play('switch')
      Sound.toggleMute()
      if (Sound.muted) {
        this.$refs['sound'].classList.add('off')
      } else {
        this.$refs['sound'].classList.remove('off')
      }
    },

    update(){
      for (let i = 0; i < this.points.length; i++) {
        const p = this.points[i]
        p.time += RAF.dt / 1000
        p.offset = Math.easing.easeInQuad(p.time) * -100
        if (p.time > 1) {
          this.points.splice(i, 1)
        }
      }
    }
  }
}
</script>
